import { Component, Input, Output, EventEmitter } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { NgxMatTimepickerModule } from "ngx-mat-timepicker";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faArrowDown, faArrowUp, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { VFIconComponent } from "../../../../vficon/vficon.component";
import { CellChangeEvent, ExclusionTypeConfig, TableCell, TableRow } from "../../../../../models/common-table";
import { CommonTableGridHandlers } from "../common-table-grid.component";
import { getCellValueAsArray, getCellValueAsString } from "../../../../../utils/common-table.utils";

@Component({
  selector: "app-cell-subtype-renderer",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TooltipModule,
    MatFormFieldModule,
    MatInputModule,
    NgxMatTimepickerModule,
    FontAwesomeModule,
    VFIconComponent,
  ],
  templateUrl: "./cell-subtype-renderer.component.html",
  styleUrls: ["../../../common-table.component.scss"],
})
export class CellSubtypeRendererComponent {
  @Input() cell: TableCell<unknown> | undefined;
  @Input() rowIndex!: number;
  @Input() colIndex!: number;
  @Input() columnTitle!: string;
  @Input() handlers!: CommonTableGridHandlers;
  @Input() row: TableRow | undefined;
  @Input() weekDays: unknown[] = [];
  @Input() daysOfWeek: string[] = [];
  @Input() exclusionTypes: ExclusionTypeConfig[] = [];

  @Output() cellChange: EventEmitter<CellChangeEvent> = new EventEmitter<CellChangeEvent>();

  public readonly faArrowUp: IconDefinition = faArrowUp;
  public readonly faArrowDown: IconDefinition = faArrowDown;
  public readonly isArray: (value: unknown) => value is unknown[] = Array.isArray;

  // Utility functions exposed for template use.
  public readonly getCellValueAsArray: (value: unknown) => unknown[] = getCellValueAsArray;
  public readonly getCellValueAsString: (value: unknown) => string = getCellValueAsString;

  public onCellChange(
    event: unknown,
    data: unknown,
    column: string,
    rowData: TableRow,
    options?: Record<string, unknown> | null,
    action?: string,
  ): void {
    this.cellChange.emit({ event, data, column, row: rowData, options, action });
  }
}
